@if (masterData) {
  <sis-map
    class="sis-map"
    [masterData]="masterData"
    [showSlopeLabels]="showSlopeLabels"
    [backgroundColor]="backgroundColor"
    [editMode]="editMode"
  ></sis-map>
  <sis-layer-selector
    [hideLayerSelector]="hideLayerSelector"
    [hideSeasonFilter]="hideSeasonFilter"
    [hideSignPosts]="hideSignPosts"
    [openLayerSelector]="openLayerSelector"
    [season]="masterData.season"
    [sisId]="masterData.sisId"
    [areaUrlName]="masterData.areaUrlName"
    [oppositeMapExist]="masterData.oppositeMapExist"
    data-test="sis-layer-selector"
  ></sis-layer-selector>
}
